module.exports = __webpack_public_path__ + "img/undertakingCases22.c60e8d1d.jpg";